/**
 * @param parent {Node}
 * @param child {Node | string}
 */
module.exports = function afterElement(parent, child) {
    parent.after(child);
}
